// extracted by mini-css-extract-plugin
module.exports = {"entryCard":"EntryCard__entryCard__1eIvK","shadow":"EntryCard__shadow__2QpKr"};